import { getWindowOptions } from 'utils/hooks/storage/storageGets';

export const url_dashboard = {
	summary: '/reports/dashboard/summary/',
	overview_new_users: '/reports/dashboard/overview/new-users/',
	overview_new_orders: '/reports/dashboard/overview/new-orders/',
	overview_expiring_invoices: '/reports/dashboard/overview/expiring-invoices/',
	overview_published_invoices: '/reports/dashboard/overview/published-invoices/',
	ranking_orders: '/reports/dashboard/ranking/orders/',
	ranking_suppliers_sales_turnover: '/reports/dashboard/ranking/suppliers-sales-turnover/',
	ranking_orders_count: '/reports/dashboard/ranking/orders-count/',
	ranking_supplier_margin: '/reports/dashboard/ranking/supplier-margin/',
	ranking_agreement_orders: '/reports/dashboard/ranking/agreement-orders/',
	ranking_agreement_orders_count: '/reports/dashboard/ranking/agreement-orders-count/',
	external_applies: '/reports/dashboard/external-applies/'
};

const dashboard = service => ({
	getSummary: ({ agreementSlug }) => {
		return service.get(url_dashboard.summary, {
			params: {
				agreementSlug
			}
		});
	},
	getOverviewNewUsers: ({ groupBy, dateFrom, dateTo, agreementSlug, page, rowsPerPage, currentTab, sortParameter, isOrderByAsc }) => {
		const order = sortParameter && `${isOrderByAsc ? '' : '-'}${sortParameter}`;
		const { paginationLimitTable } = getWindowOptions();

		const defaultOrder = {};

		const pagination = Object.assign({},
			order ? { sortBy: order } : defaultOrder[currentTab],
			rowsPerPage && { pageSize: rowsPerPage },
			page && { page: page + 1 }
		);

		return service.get(url_dashboard.overview_new_users, {
			params: {
				groupBy,
				dateFrom,
				dateTo,
				agreementSlug,
				pageSize: paginationLimitTable,
				...pagination,
			}
		});
	},
	getOverviewNewOrders: ({ groupBy, dateFrom, dateTo, agreementSlug, page, rowsPerPage, currentTab, sortParameter, isOrderByAsc }) => {
		const order = sortParameter && `${isOrderByAsc ? '' : '-'}${sortParameter}`;
		const { paginationLimitTable } = getWindowOptions();

		const defaultOrder = {};

		const pagination = Object.assign({},
			order ? { sortBy: order } : defaultOrder[currentTab],
			rowsPerPage && { pageSize: rowsPerPage },
			page && { page: page + 1 }
		);

		return service.get(url_dashboard.overview_new_orders, {
			params: {
				groupBy,
				dateFrom,
				dateTo,
				agreementSlug,
				pageSize: paginationLimitTable,
				...pagination,
			}
		});
	},

	getOverviewExpiringInvoices: ({ groupBy, dateFrom, dateTo, agreementSlug, page, rowsPerPage, currentTab, sortParameter, isOrderByAsc }) => {
		const order = sortParameter && `${isOrderByAsc ? '' : '-'}${sortParameter}`;
		const { paginationLimitTable } = getWindowOptions();

		const defaultOrder = {};

		const pagination = Object.assign({},
			order ? { sortBy: order } : defaultOrder[currentTab],
			rowsPerPage && { pageSize: rowsPerPage },
			page && { page: page + 1 }
		);

		return service.get(url_dashboard.overview_expiring_invoices, {
			params: {
				groupBy,
				dateTo,
				dateFrom,
				agreementSlug,
				pageSize: paginationLimitTable,
				...pagination,
			}
		});
	},

	getOverviewPublishedInvoices: ({ groupBy, dateFrom, dateTo, agreementSlug, page, rowsPerPage, currentTab, sortParameter, isOrderByAsc }) => {
		const order = sortParameter && `${isOrderByAsc ? '' : '-'}${sortParameter}`;
		const { paginationLimitTable } = getWindowOptions();

		const defaultOrder = {};

		const pagination = Object.assign({},
			order ? { sortBy: order } : defaultOrder[currentTab],
			rowsPerPage && { pageSize: rowsPerPage },
			page && { page: page + 1 }
		);

		return service.get(url_dashboard.overview_published_invoices, {
			params: {
				groupBy,
				dateTo,
				dateFrom,
				agreementSlug,
				pageSize: paginationLimitTable,
				...pagination,
			}
		});
	},

	getRankingOrders: ({ dateTo, dateFrom, agreementSlug, page, rowsPerPage, currentTab, sortParameter, isOrderByAsc }) => {
		const order = sortParameter && `${isOrderByAsc ? '' : '-'}${sortParameter}`;
		const { paginationLimitTable } = getWindowOptions();

		const defaultOrder = {};

		const pagination = Object.assign({},
			order ? { sortBy: order } : defaultOrder[currentTab],
			rowsPerPage && { pageSize: rowsPerPage },
			page && { page: page + 1 }
		);

		return service.get(url_dashboard.ranking_orders, {
			params: {
				pageSize: paginationLimitTable,
				dateFrom,
				dateTo,
				agreementSlug,
				...pagination,
			}
		});
	},
	getRankingSuppliersSalesTurnover: ({ dateTo, dateFrom, agreementSlug, page, rowsPerPage, currentTab, sortParameter, isOrderByAsc }) => {
		const order = sortParameter && `${isOrderByAsc ? '' : '-'}${sortParameter}`;
		const { paginationLimitTable } = getWindowOptions();

		const defaultOrder = {};

		const pagination = Object.assign({},
			order ? { sortBy: order } : defaultOrder[currentTab],
			rowsPerPage && { pageSize: rowsPerPage },
			page && { page: page + 1 }
		);

		return service.get(url_dashboard.ranking_suppliers_sales_turnover, {
			params: {
				pageSize: paginationLimitTable,
				dateFrom,
				dateTo,
				agreementSlug,
				...pagination,
			}
		});
	},
	getExternalApplies: ({ dateTo, dateFrom, agreementSlug, page, rowsPerPage, currentTab, sortParameter, isOrderByAsc }) => {
		const order = sortParameter && `${isOrderByAsc ? '' : '-'}${sortParameter}`;
		const { paginationLimitTable } = getWindowOptions();

		const defaultOrder = {};

		const pagination = Object.assign({},
			order ? { sortBy: order } : defaultOrder[currentTab],
			rowsPerPage && { pageSize: rowsPerPage },
			page && { page: page + 1 }
		);

		return service.get(url_dashboard.external_applies, {
			params: {
				pageSize: paginationLimitTable,
				dateFrom,
				dateTo,
				agreementSlug,
				...pagination,
			}
		});
	},
	postExternalApplies: ({ slugs, action }) => {
		return service.post(url_dashboard.external_applies, { slugs, action });
	},
	getRankingOrdersCount: ({ dateFrom, dateTo, agreementSlug, page, rowsPerPage, currentTab, sortParameter, isOrderByAsc }) => {
		const order = sortParameter && `${isOrderByAsc ? '' : '-'}${sortParameter}`;
		const { paginationLimitTable } = getWindowOptions();

		const defaultOrder = {};

		const pagination = Object.assign({},
			order ? { sortBy: order } : defaultOrder[currentTab],
			rowsPerPage && { pageSize: rowsPerPage },
			page && { page: page + 1 }
		);

		return service.get(url_dashboard.ranking_orders_count, {
			params: {
				pageSize: paginationLimitTable,
				dateFrom,
				dateTo,
				agreementSlug,
				...pagination,
			}
		});
	},
	getRankingSupplierMargin: ({ dateFrom, dateTo, agreementSlug, page, rowsPerPage, currentTab, sortParameter, isOrderByAsc }) => {
		const order = sortParameter && `${isOrderByAsc ? '' : '-'}${sortParameter}`;
		const { paginationLimitTable } = getWindowOptions();

		const defaultOrder = {};

		const pagination = Object.assign({},
			order ? { sortBy: order } : defaultOrder[currentTab],
			rowsPerPage && { pageSize: rowsPerPage },
			page && { page: page + 1 }
		);

		return service.get(url_dashboard.ranking_supplier_margin, {
			params: {
				pageSize: paginationLimitTable,
				dateFrom,
				dateTo,
				agreementSlug,
				...pagination,
			}
		});
	},
	getRankingAgreementOrders: ({ dateFrom, dateTo, agreementSlug, page, rowsPerPage, currentTab, sortParameter, isOrderByAsc }) => {
		const order = sortParameter && `${isOrderByAsc ? '' : '-'}${sortParameter}`;
		const { paginationLimitTable } = getWindowOptions();

		const defaultOrder = {};

		const pagination = Object.assign({},
			order ? { sortBy: order } : defaultOrder[currentTab],
			rowsPerPage && { pageSize: rowsPerPage },
			page && { page: page + 1 }
		);

		return service.get(url_dashboard.ranking_agreement_orders, {
			params: {
				pageSize: paginationLimitTable,
				dateFrom,
				dateTo,
				agreementSlug,
				...pagination,
			}
		});
	},
	getRankingAgreementOrdersCount: ({ dateFrom, dateTo, agreementSlug, page, rowsPerPage, currentTab, sortParameter, isOrderByAsc }) => {
		const order = sortParameter && `${isOrderByAsc ? '' : '-'}${sortParameter}`;
		const { paginationLimitTable } = getWindowOptions();

		const defaultOrder = {};

		const pagination = Object.assign({},
			order ? { sortBy: order } : defaultOrder[currentTab],
			rowsPerPage && { pageSize: rowsPerPage },
			page && { page: page + 1 }
		);

		return service.get(url_dashboard.ranking_agreement_orders_count, {
			params: {
				pageSize: paginationLimitTable,
				dateFrom,
				dateTo,
				agreementSlug,
				...pagination,
			}
		});
	}
});

export default dashboard;
